export default __webpack_public_path__ + "images/c169fbfe315ae349bda16dd1f37e6957-do_7.png";